<template>
  <div>
    <div class="w-full bg-gray-100 flex justify-center">
      <div class="text-center py-1 my-2">
        <v-date-picker
          :allowed-dates="allowedDates"
          class="w-full"
          color="#7F170E"
          v-model="selected_date"
        ></v-date-picker>

        <!-- Selected Date : {{ selected_date }}   -->
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      selected_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      badDates: [
        "Jan 1",
        "Apr 9",
        "Apr 14",
        "Apr 15",
        "May 1",
        "May 3",
        "June 12",
        "Jul 9",
        "Aug 29",
        "Nov 30",
        "Dec 25",
        "Dec 30",
      ],
    };
  },
  watch: {
    selected_date: {
      handler(e) {
        this.$emit("on_selected_date", e);
      },
      immediate: true,
    },
  },
  methods: {
    allowedDates(d) {
      return (
        // For every bad date, current date must not be equal to bad date
        this.badDates.every(
          (badDate) =>
            !moment(d)
              .format("MMM Do")
              .includes(badDate)
        ) && moment(d).day() != 0
      );
    },
  },
};
</script>
